export const shuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const randomIndex = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[randomIndex]] = [newArray[randomIndex], newArray[i]];
    }
    return newArray;
};
export async function readStream(stream, options) {
    const output = [];
    const reader = stream.getReader();
    while (true) {
        let result;
        try {
            result = await reader.read();
        }
        catch (e) {
            if (options?.onError) {
                await options.onError(e);
                continue;
            }
            else {
                throw e;
            }
        }
        if (result.value) {
            output.push(result.value);
            if (options?.onValue) {
                await options.onValue(result.value);
            }
        }
        if (result.done) {
            break;
        }
    }
    return output;
}
//# sourceMappingURL=utils.js.map